import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Pusher'ı window'a ekle (Echo için gerekli)
(window as any).Pusher = Pusher;

/**
 * Laravel Echo instance
 * Reverb WebSocket sunucusuna bağlanır
 */
// Production değerleri - Caprover'da env var olmadan çalışması için hardcode
const REVERB_CONFIG = {
    key: 'okuratolyesi-reverb-key',
    host: 'web.okuratolyesi.com',
    port: 443,
    scheme: 'https',
};

const echo = new Echo({
    broadcaster: 'reverb',
    key: REVERB_CONFIG.key,
    wsHost: REVERB_CONFIG.host,
    wsPort: REVERB_CONFIG.port,
    wssPort: REVERB_CONFIG.port,
    forceTLS: REVERB_CONFIG.scheme === 'https',
    enabledTransports: ['ws', 'wss'],
});

export default echo;
